import { css } from "@emotion/css";
import type { Properties } from "signlets";

const style = css`
  margin: 0;
`;

export const H2 = ({ children }: Properties<{ children: JSX.Element }>) => (
  <h2 class={style}>{children}</h2>
);
